import RequestAbstract from "../abstract";

export default class PDF extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/pdf";
    }

}
